import { IChartState } from '../types/charts';
import { IApplicationState } from '../types/redux';

export function getChartsData(chartType: keyof Omit<IChartState, 'loading'>) {
  return (state: IApplicationState) => {
    return state.charts[chartType];
  };
}
